export enum SmtpEncryption {
    None = 'none',
    Ssl = 'ssl',
    Tls = 'tls',
}